import { ReactNode } from 'react'

import styles from './CheckboxList.module.css'

type CheckboxListProps = { children: ReactNode }

const CheckboxList = ({ children }: CheckboxListProps): JSX.Element => (
  <div className={styles.wrapper}>{children}</div>
)

export default CheckboxList
